import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeveloperRoutingModule } from './developer-routing.module';
import { UIModule } from 'app/ui/ui.module';
import { DeveloperAutoComponent } from './developer-auto/developer-auto.component';

@NgModule({
	declarations: [
		DeveloperAutoComponent
	],
	imports: [
		CommonModule,
		DeveloperRoutingModule,
		UIModule
	]
})
export class DeveloperModule { }
